<script>
import resources from './resources'

export default {
  name: 'links-profile',
  mixins: [resources]
}
</script>

<template lang="pug">
   ul
      //- social linkedin
      a(v-if="prepareLinkedin(links)", :href='prepareLinkedin(links)', target="_blank")
        li
          img(src='/static/images/icons/linkedin-icon.svg')
      a.mb-cursor-point(v-if="!prepareLinkedin(links)")
        li
          img(src='/static/images/icons/linkedin-icon.svg')

      //- profile professional
      a.cursor-point(@click.prevent="openProfileProfessional(documentState, state)", )
       li
        img(src='/static/images/icons/perfil-icon.svg')

      //- social professional lattes
      a(v-if="prepareLattes(links)", :href='prepareLattes(links)', target="_blank")
        li
          img(src='/static/images/icons/share-icon.svg')
      a.mb-cursor-point(v-if="!prepareLattes(links)")
        li
         img(src='/static/images/icons/share-icon.svg')
</template>



// WEBPACK FOOTER //
// src/app/patient/loading-page/components/links-profile/links.vue